$(document).ready(function () {
    $('.partnerSliderOdd').owlCarousel({
        items: 3,
        margin: 30,
        dots: false,
        loop: true,
        autoplay: true,
        center: true,
        autoplayTimeout: 2500,
    });
    $('.partnerSliderEven').owlCarousel({
        items: 3,
        margin: 30,
        dots: false,
        loop: true,
        autoplay: true,
        center: false,
        autoplayTimeout: 2500,
        rtl: true,
    });
});



// WEBPACK FOOTER //
// ./scripts/modules/partners.js